export const ToolControls = [
  'Voyage_Consumption_Estimator',
  'Data_Export',
  'Fuel_Curves',
  'Wind_Assist_Experiments',
  'Voyage_Experiments',
  'Engine_Cooling_System_Optimization',
  'Charter_Party_Agreement',
  'Alarms_Monitoring_System',
  'Fuel_Levels',
  'Noon_Reports',
] as const;

export type ToolControlKey = (typeof ToolControls)[number];
